// extracted by mini-css-extract-plugin
export default {"Subreddit":"Subreddit_Subreddit__K4yVO","subs":"Subreddit_subs__2m0rE","topic":"Subreddit_topic__rremH","subInfo":"Subreddit_subInfo__fgKMk"};